// import { lazy, Suspense } from "react";
// import { useParams } from "react-router-dom";

// const companyComponents = {
//     // indoasain: lazy(() => import("./companylogin/indoasain").then(m => ({ default: m.IndoasainLogin }))),
//     mitr: lazy(() => import("./companylogin/mitr").then(m => ({ default: m.Login }))),
//     // Easy to add more companies here
// };

// export function ClientLogin() {
//     const { company } = useParams();
//     const CompanyComponent = companyComponents[company?.toLowerCase()];

//     if (!CompanyComponent) {
//         return (
//             <div className="d-flex flex-center w-100 h-100 p-10">
//                 <div className="text-center">
//                     <h2 className="text-dark fw-bold mb-3">Company Not Found</h2>
//                     <p className="text-gray-600 fs-5">
//                         The company "{company}" is not recognized.
//                     </p>
//                 </div>
//             </div>
//         );
//     }

//     return (
//         <Suspense fallback={<div className="d-flex flex-center w-100 h-100">Loading...</div>}>
//             <div className="d-flex flex-column flex-lg-row flex-column-fluid">
//                 <div className="d-flex flex-center w-lg-100 p-10">
//                     <div style={{ background: '#fbfbfb' }} className="card  rounded-3 w-lg-900px">
//                         <div className="card-body p-2 p-lg-20">
//                             <CompanyComponent />
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </Suspense>
//     );
// }
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { changeBranding, toAbsoluteUrl } from "../../../../_metronic/helpers";
import { useAuth } from "../core/Auth";
import { getComapnyByKey } from "../../../users-section/projectData";
import { useParams } from "react-router-dom";
import { authLoginOtp, sendOTP } from "../../../users-section/api";
import OTPInput, { ResendOTP } from "otp-input-react";
import { getUserByToken } from "../core/_requests";

export function ClientLogin() {
    const { company } = useParams();
    const [loading, setLoading] = useState(false);
    const [project, setProject] = useState(null);
    const [step, setStep] = useState("phone");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [error, setError] = useState("");
    const [OTP, setOTP] = useState("");
    const [timerKey, setTimerKey] = useState(0);
    const [otpError, setOtpError] = useState("");
    const { saveAuth, setCurrentUser } = useAuth();

    useEffect(() => {
        const projectData = getComapnyByKey(company);
        changeBranding(projectData?.cname, projectData?.logo);
        if (projectData) setProject(projectData);
    }, [company]);

    const validatePhone = (phone) => /^[0-9]{10}$/.test(phone);

    const handleOTPAction = async (action = "submit") => {
        setError("");
        setLoading(true);
        try {
            if (!validatePhone(phoneNumber)) {
                setError("Phone number must be 10 digits");
                return;
            }
            const otpData = {
                mobile: phoneNumber,
                type: "login",
                login_type: "companyPortal",
                ...(getComapnyByKey(company)?.ckey ? { company_key: getComapnyByKey(company)?.ckey } : { project_key: project?.pkey })
            };
            const response = await sendOTP(otpData);
            if (response.code === 1) {
                setStep("otp");
                if (action === "resend") setError("");
            } else {
                setError(response.message || "Failed to send OTP");
            }
        } catch (err) {
            console.error(err);
            setError("Invalid details. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async () => {
        setLoading(true);
        setError("");
        try {
            const { data: auth } = await authLoginOtp({
                mobile: phoneNumber,
                login_type: "companyPortal",
                otp: OTP
            });
            saveAuth(auth);
            const { data: user } = await getUserByToken(auth.api_token);
            setCurrentUser(user);
        } catch (error) {
            console.error(error);
            saveAuth(undefined);
            setOtpError('The login details are incorrect');
            setLoading(false);
        }
    };

    const handleResendOTP = () => {
        handleOTPAction("resend");
        setTimerKey(prev => prev + 1);
    };

    const renderButton = (buttonProps) => buttonProps.remainingTime !== 0 ? null : (
        <>
            <span className="text-muted me-1">Didn't get the code?</span>
            <button type="button" {...buttonProps} onClick={handleResendOTP} className="btn btn-sm btn-primary">Resend</button>
        </>
    );

    return (
        <div className="d-flex flex-column flex-lg-row flex-column-fluid">
            <div className="d-flex flex-center w-lg-100 p-10">
                <div style={{ background: "#fbfbfb" }} className="card rounded-3 w-lg-900px shadow-sm">
                    <div className="card-body p-2 p-lg-20">
                        <div className="d-flex flex-column flex-lg-row flex-column-fluid">
                            <div className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-3 order-2 order-lg-1">
                                <div className="text-left">
                                    <img alt="Logo" className="mx-auto w-200px w-md-50 w-xl-200px mb-1 mb-lg-10" src={project?.logo} />
                                </div>
                                <div className="form w-100">
                                    <div className="text-left mb-6">
                                        <h1 className="text-dark fw-semibolder mb-3">Sign In</h1>
                                        <div className="text-gray-500 fw-semibold fs-6">
                                            Please enter your registered mobile number to receive an OTP and securely sign in to your company portal.
                                        </div>
                                    </div>

                                    {step === "phone" && (
                                        <>
                                            {error && (
                                                <div className="mb-lg-6 alert alert-danger">
                                                    <div className="alert-text font-weight-bold">{error}</div>
                                                </div>
                                            )}
                                            <div className="fv-row mb-5">
                                                <label className="form-label fs-6 fw-semibolder text-dark">Mobile Number</label>
                                                <input placeholder="Eg. 999999999" className={clsx("form-control form-control-lg", { "is-invalid": error })} type="text" name="phone" value={phoneNumber} onChange={(e) => {
                                                    const value = e.target.value.replace(/\D/g, ''); // Remove non-digits
                                                    if (value.length <= 10) {
                                                        setPhoneNumber(value);
                                                    }
                                                }} autoComplete="off" />
                                            </div>
                                            <div className="d-grid mt-5">
                                                <button type="button" className="btn btn-lg btn-primary fw-bold" disabled={loading} onClick={() => handleOTPAction("submit")}>
                                                    {loading ? "Sending..." : "Send OTP"}
                                                </button>
                                            </div>
                                        </>
                                    )}

                                    {step === "otp" && (
                                        <>
                                            {otpError && (
                                                <div className="mb-lg-6 alert alert-danger">
                                                    <div className="alert-text font-weight-bold">{otpError}</div>
                                                </div>
                                            )}
                                            <div className="mb-10 text-center">
                                                <div className="fw-semibolder text-start text-dark fs-6 mb-1 ms-1">Type your 4 digit otp code</div>
                                                <div className="d-flex flex-wrap flex-stack">
                                                    <OTPInput value={OTP} onChange={setOTP} inputClassName="form-control form-control-solid h-60px w-60px fs-2qx text-center border-primary border-hover mx-1 my-2" autoFocus OTPLength={4} otpType="number" disabled={false} />
                                                </div>
                                            </div>
                                            <div className="text-center">
                                                <div className="d-flex flex-stack">
                                                    <button type="button" id="kt_cancell_in_submit" className="btn btn-lg w-100 mb-5 me-3" style={{ background: '#0E295E' }} disabled={loading} onClick={() => { setStep("phone"); setOtpError(""); setOTP(""); }}>
                                                        <span className="indicator-label text-white">Cancel</span>
                                                    </button>
                                                    <button id="kt_otp_in_submit" className="btn btn-lg btn-primary w-100 mb-5" disabled={!OTP} onClick={handleSubmit}>
                                                        {!loading && <span className="indicator-label">Continue</span>}
                                                        {loading && (
                                                            <span className="indicator-progress" style={{ display: 'block' }}>
                                                                Please wait...<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                            </span>
                                                        )}
                                                    </button>
                                                </div>
                                                <div className="text-center fw-semibold fs-5">
                                                    <ResendOTP key={timerKey} maxTime={90} onTimerComplete={() => console.log("Timer ended")} renderButton={renderButton} renderTime={() => React.Fragment} />
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>

                            <div className="d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2">
                                <div className="d-flex flex-lg-row-fluid">
                                    <div className="d-flex flex-column flex-center py-15 px-5 px-md-15 w-100">
                                        <img className="mx-auto w-200px w-md-25 w-xl-150px mb-10 mb-lg-10" src={toAbsoluteUrl("/media/logos/key@2x.png")} alt="" />
                                        <h2 style={{ color: "#3E3E3E" }} className="fs-2px text-center mb-3">Passwordless sign-in</h2>
                                        <div style={{ color: "#333333" }} className="fs-2px fs-base text-center">Secure login with OTP on your registered phone number.</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
